var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nav',[_c('div',{staticClass:"window-overlay",on:{"click":function($event){if($event.target !== $event.currentTarget)return null;$event.stopPropagation();return _vm.hide()}}}),_c('div',{staticClass:"dropdown-content",style:({ paddingTop: `${_vm.paddingTop}px` })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }